import { VideoTemplateState, VideoTemplateStateContent } from '../types';

export function getStateContent(
  state: VideoTemplateState,
): VideoTemplateStateContent {
  return state?.present;
}
